import React from 'react';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import imgLogoWhite from '../../img/logo-white-green.png';
import imgSocFbWhite from '../../img/soc/soc-fb-white.svg';
import imgSocTwWhite from '../../img/soc/soc-tw-white.svg';
import imgSocIgWhite from '../../img/soc/soc-ig-white.svg';
import imgSocYtWhite from '../../img/soc/soc-yt-white.svg';
// translate
import messages from './messages';

function Footer(props) {
  const { intl } = props;
  return (
    <footer className="container-fluid">
      <div className="row footer-top">
        <div className="container">
          <div className="row">
            <div className="footer-left col-xs-12 col-sm-6">
              <div className="row">
                <ul className="col-sm-4 footer-links">
                  <li>
                    <strong>{intl.formatMessage(messages.company)}</strong>
                  </li>
                  <li>
                    <a href="https://art.art/what-is-art/">
                      <FormattedHTMLMessage {...messages.whatIsART} />
                    </a>
                  </li>
                  <li>
                    <a href="https://art.art/community/">
                      <FormattedHTMLMessage {...messages.community} />
                    </a>
                  </li>
                  <li>
                    <a href="https://art.art/news/">
                      {intl.formatMessage(messages.latestNews)}
                    </a>
                  </li>
                  <li>
                    <a href="https://art.art/contact/">
                      {intl.formatMessage(messages.contact)}
                    </a>
                  </li>
                </ul>

                <ul className="col-sm-4 footer-links">
                  <li>
                    <strong>{intl.formatMessage(messages.support)}</strong>
                  </li>
                  <li>
                    <a href="http://nic.art/">
                      {intl.formatMessage(messages.registrarPortal)}
                    </a>
                  </li>
                  <li>
                    <a href="https://art.art/registrars/">
                      {intl.formatMessage(messages.registrars)}
                    </a>
                  </li>
                  <li>
                    <a href="https://art.art/faq/">
                      {intl.formatMessage(messages.faq)}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer-right col-xs-12 col-sm-6">
              <img
                className="footer-logo"
                src={imgLogoWhite}
                alt={intl.formatMessage(messages.logoAlt)}
              />

              <ul className="footer-social">
                <li>
                  <a
                    href="https://www.facebook.com/ArtDomains"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <img src={imgSocFbWhite} alt="" target="_blank" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/Art_Domains"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <img src={imgSocTwWhite} alt="" target="_blank" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/artdomains"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <img src={imgSocIgWhite} alt="" target="_blank" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCm1Bg9sukZSa2JA8rP4du4g"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <img src={imgSocYtWhite} alt="" target="_blank" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="row footer-bottom">
        <div className="container">
          <div className="row">
            <div className="footer-left col-xs-12 col-sm-6">
              <ul className="footer-links-bottom">
                <li>
                  <a href="https://art.art/terms/">
                    <FormattedHTMLMessage {...messages.terms} />
                  </a>
                </li>
                <li>
                  <a href="http://art.art/wp-content/uploads/2017/05/DotART-Policies.pdf">
                    {intl.formatMessage(messages.policies)}
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-right col-xs-12 col-sm-6">
              <p className="footer-copyrights">
                &copy; {intl.formatMessage(messages.copyright)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js